import { RequestTypes } from '../../../../hooks/useRequest'

export const GREEN_TOOLS_API_PREFIX = '/api/green-tools/v1/'
export const GREEN_TOOLS_DELETE = 'certificate/delete'

export const deleteCertificate = {
    link: `${GREEN_TOOLS_API_PREFIX}${GREEN_TOOLS_DELETE}`,
    method: RequestTypes.post,
}
